import PropTypes from 'prop-types'

const FileHeader = ({ title }) => {
    return (
        <header className='header'>
            <h1>{title}</h1>
        </header>
    )
}

FileHeader.defaultProps = {
    title: 'Info Hub',
}

FileHeader.propTypes = {
    title: PropTypes.string.isRequired,
}

export default FileHeader
